module.exports = __webpack_public_path__ + "img/SO.a83cf250.svg";